<script setup>
import { RouterView } from 'vue-router'
import TopNav from './components/TopNav.vue'
import TopHeader from './components/TopHeader.vue'
import Footer from './components/Footer.vue'
</script>
<script>
// import { initStore } from './store'
export default {
  created(){
    // initStore()
      //что-то делаем когда меняется local storage
    window.addEventListener('storage', () => {
      console.log("storage changed")
    })
  }
}
</script>

<template>
<!-- <div class="container-lg gx-0 px-0"> -->
<div class="container-lg">
  <notifications position="bottom center" :pauseOnHover=true width="100%" classes="my-notify"/>
  <top-header></top-header>
  <TopNav/>
  <div class="row d-flex">
    <div class="col-12">
      <RouterView/>
    </div>
  </div>
</div>
  <!-- <div class="mt-auto">
  <Footer/>
  </div> -->
</template>
<style>
.my-notify {
  margin: 0 5px 5px;
  padding: 10px;
  font-size: 0.8em;
  color: #777;
  background: white;
  border-left: 8px solid var(--clr-yellow);

  &.success {
    border-left-color: #8bb697;
  }

  &.warn {
    border-left-color: var(--clr-yellow);
  }

  &.error {
    border-left-color: #b82e24;
    color: #e63e32;
  }
}
</style>
